import React from "react";
import { List, Heading } from "arwes";

const Myths = () =>{


    return(
        <div>
            <List node='ol'>
                <Heading node='h2'><li> If it's really good, it's not science fiction</li></Heading>
                <p>You still see this one a lot in book reviews and movie/TV write-ups a lot. It's not just a matter of genre snobbery,
                    but of clinging to the idea that science fiction is a particular type of narrative,
                    with one-dimensional characters and Lucasian dialogue.
                    This attitude is summed up by Kingsley Amis' handy poem: "SF's no good! They bellow 'til we're deaf.
                    But this is good. Well, then, it's not SF!"
                </p>

                <p>
                    Why this matters: Not so much because of the thing where certain outstanding works get mis-classified as being "not science fiction"
                    — that's just a minor annoyance — but more because this attitude, perversely, leads to people creating absolutely terrible science fiction,
                    with the understanding that we don't expect or deserve anything better.
                </p>




                <Heading node='h2'><li> Similarly, if it's realistic and near future, it's not SF</li></Heading>
                <p>I've seen a lot of people trying to claim Gravity isn't science fiction.
                    Not because it's good, or plausible, but because it's too close to reality.
                    Here are the questions you need to ask about Gravity: 1) Is it fictional? 2) Is it about science? 3) Is science important to the story? The answer to all three is clearly "Yes." If you want to claim Gravity isn't science fiction, then you're saying George Clooney is an astronaut in real life.
                    And similar debates crop up about "lab lit" and other stories that hew closely to reality.
                </p>

                <p>
                    Why this matters: Well, it would suck if science fiction creators felt as though nobody was expecting them to try and borrow from Alfonso Cuaron's achievement in Gravity.
                    And in spite of the thing above about science fiction writers not needing science degrees,
                    we should be encouraging more realism in science fiction — and not declaring some point of realism which science fiction can approach asymptotically but not ever be allowed to reach.
                </p>



                <Heading node='h2'><li> Science fiction is intended to predict the future</li></Heading>
                <p>You see tons of articles examining "predictions for 2012 or 2013 from science fiction" — and some of them seem to be grading SF from the 1950s and 1960s on how accurately it predicted the present.
                    But really, that's like grading a drummer on flower arrangement. Science fiction doesn't really aim to predict the future.
                    Writers from Cory Doctorow to William Gibson to Kim Stanley Robinson have debunked this one.
                </p>

                <p>
                    Why this matters: As Doctorow says, it lets people say things like, "science fiction is dead, because the future is here."
                    Or point to incorrect predictions as a way of downgrading the usefulness of the genre — when, in fact, science fiction always speaks about the present, and in this capacity it's more powerful a tool than ever for understanding the completely bonkers world we live in.
                </p>





                <Heading node='h2'><li>Science fiction is stuff that could never actually happen</li></Heading>
                <p>This is a close cousin of the "science fiction can't be good" argument — for example, when Margaret Atwood tries to claim she's never written science fiction, she frequently uses this argument.
                    But you also see this idea in political discourse — set up a Google alert for the phrase "science fiction," and you'll see a steady trickle of headlines like "government's economic plan is science fiction" or "new jobs plan is science fiction" —
                    the implication being that this means some politician or thinktank has said something totally unrealistic.

                </p>

                <p>
                    Why this matters: It subtly encourages people not to speculate boldly, because there's this thing called "science fiction" wherein we categorize things that go beyond the pale.
                    And it also spreads the idea that science fiction cannot speak realistically about our present-day experiences — thus depriving us all of an important tool.
                </p>



                <Heading node='h2'><li>Science fiction is inherently liberal/conservative/libertarian/socialist</li></Heading>
                <p>I feel like this one is more implicit than explicit. There are certain authors or creators that both right-wingers and left-wingers will try to claim ownership of.
                    Google "science fiction is conservative" and "science fiction is progressive" and you'll see tons of pieces that either argue those propositions, or simply assume that you'll agree with them.
                    In fact, science fiction is way too broad to be limited to one political point of view.

                </p>

                <p>
                    Why this matters: Not just because this belief could constrain the scope of political science fiction — but also because you have to assume the people who believe science fiction is inherently progressive aren't reading the great conservative authors in the genre, or vice versa.
                    And that means people aren't getting exposed to challenging, bracing ideas.
                </p>
            </List>



            <Heading className="text-right" node='h6'>source:https://gizmodo.com/</Heading>
        </div>
    )
}
export default Myths